import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FloatingConsult from '@/components/feature/solution/FloatingConsult';
import AgriHero from './components/AgriHero';
import AgriPainPoints from './components/AgriPainPoints';
import AgriCapabilities from './components/AgriCapabilities';
import AgriSoftwareModules from './components/AgriSoftwareModules';
import AgriArchDiagram from './components/AgriArchDiagram';
import AgriTopology from './components/AgriTopology';
import AgriHardware from './components/AgriHardware';
import AgriScenarios from './components/AgriScenarios';
import AgriDigitalId from './components/AgriDigitalId';
import AgriValues from './components/AgriValues';
import {
  hero,
  painPoints,
  capabilities,
  softwareModules,
  topology,
  hardware,
  scenarios,
  digitalId,
  values,
} from '@/mocks/smart-agriculture';

export default function SmartAgriculture() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧农业解决方案｜农业物联网与产品溯源｜华辉数智"
        description="华辉数智智慧农业解决方案，以 AIoT 为底座，采用终端感知、网络连接、数据智能、业务应用四层一体化架构，覆盖实时监控、精准植保、自动灌溉施肥与环境调控，打通种植、养殖、农资、检测、仓储、运输、销售与 ePin 溯源全过程，实现生产可感知、过程可管理、产品可追溯、经营可分析。"
        keywords="智慧农业,农业物联网,农业传感器,农产品溯源,ePin 食安码"
        path="/solutions/smart-agriculture"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '智慧农业解决方案',
          description:
            '华辉数智智慧农业解决方案，以软硬件一体化把农田变成可被感知、可被管理的数据资产，再通过 ePin 溯源把它变成可被市场认可的品牌资产。',
        }}
      />

      <AgriHero data={hero} />
      <Breadcrumb items={[{ label: '产品与解决方案' }, { label: '解决方案', href: '/solutions' }, { label: '智慧农业' }]} />

      <main>
        <AgriPainPoints data={painPoints} />
        <AgriCapabilities data={capabilities} />
        <AgriSoftwareModules data={softwareModules} />
        <AgriArchDiagram />
        <AgriTopology data={topology} />
        <AgriHardware data={hardware} />
        <AgriScenarios data={scenarios} />
        <AgriDigitalId data={digitalId} />
        <AgriValues data={values} />
      </main>

      <Footer />
      <FloatingConsult accentKey="green" />
    </div>
  );
}